import React, { Component, useEffect, useState } from 'react';
import { MsalContext, useMsal } from "@azure/msal-react";
import { checkIfPageIsSyncedToForm, publishApp } from '../Helpers/DisplayConfig/DisplayConfig';
import { updateNode } from '../Helpers/Nodes';
import { syncGroupAttributesWithComponents, syncViewAttributesWithComponents } from '../../API/Display/Display';
import EditComponentForm from '../Display/EditComponentForm/EditComponent';
import { ComponentPropertiesProvider } from '../../Context/Display/ComponentProperties/ComponentPropertiesContext';
import { usePropsStoreSetter, usePropsStoreValue } from '../../Hooks/PropStore/usePropsStore';

export function RuntimeConfigForm(props) {

	const msalContext = useMsal();

	const publishAppFun = usePropsStoreValue("publishApp");
	const setPublishAppProp = usePropsStoreSetter("publishApp");

	const [state, setState] = useState({
		project: {},
		entity: {},
		page: {},
		component: {},
		user: {},
		error: {}
	});

	useEffect(() => {
		const { project, entity, page, user, component } = props;
		setState({
			project, entity, page, component, user
		})
		setPublishAppProp(handlePublish)
	}, []);

	async function handlePublish() {
		const {
			organisationName,
			instanceId,
			organisationId
		} = props;

		const { _id: projectId } = props.project;
		const { _id: pageId, subPageType } = props.page;
		const { _id: entityId } = props.entity;
		const { oid: userId } = props.user;

		const publishData = {
			projectId,
			organisationId,
			instanceId,
			context: msalContext,
			pageId,
			subPageType,
			entityId,
			userId,
			organisationName
		}

		const { isLinkedToForm: doFullPublish } = await checkIfPageIsSyncedToForm(entityId, pageId);

		// await syncComponentAttributes();

		const [data, err] = await publishApp(publishData, doFullPublish);

		if (err) {
			props.updatePublishErrorMessage(err);
			return;
		}

		// await updateNode("Project", projectId, { "hasSchemaChanges": false });

		propogateMessageToRuntime("Success", data?.message);
	}

	async function checkIfAFormIsSynced() {
		const { syncedComponents } = props;
		return (
			syncedComponents && syncedComponents.length > 0 &&
			syncedComponents.some(
				component => component.componentType === "Form"
			)
		);
	}

	async function syncComponentAttributes() {
		const { id, componentType } = props.component;
		if (componentType === "View" || componentType === "Form") {
			await syncViewAttributesWithComponents(id);
		} else {
			await syncGroupAttributesWithComponents(id);
		}
	}

	function propogateMessageToRuntime() {
		const runtimeURL = process.env.REACT_APP_RUNTIME_URL
		window.parent.postMessage(JSON.stringify({
			designerStatus: "Success"
		}), runtimeURL);
	}

	return (
		<ComponentPropertiesProvider>
			<EditComponentForm />
		</ComponentPropertiesProvider>
	);
}